module.exports = __webpack_public_path__ + "images/a8fb8bde1e6e4e83221839e5154b93ac-maya.png";